"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTvls = getTvls;
exports.getTVLs = getTVLs;
exports.fetchTVL = fetchTVL;
exports.fetchAlphafiV3PoolTVL = fetchAlphafiV3PoolTVL;
const tslib_1 = require("tslib");
const decimal_js_1 = require("decimal.js");
const index_js_1 = require("./index.js");
const getReceipts_js_1 = require("./sui-sdk/functions/getReceipts.js");
const prices_js_1 = require("./utils/prices.js");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
async function getTvls(poolNames) {
    const tvlMap = new Map();
    await (0, getReceipts_js_1.getMultiInvestor)();
    await (0, prices_js_1.getMultiLatestPrices)();
    await (0, getReceipts_js_1.getMultiParentPool)();
    // Use Promise.all to handle multiple promises in parallel
    await Promise.all(poolNames.map(async (poolName) => {
        const tvl = await fetchTVL(poolName, false);
        tvlMap.set(poolName, tvl);
    }));
    return tvlMap;
}
async function getTVLs() {
    const tvlMap = new Map();
    await (0, getReceipts_js_1.getMultiInvestor)();
    await (0, prices_js_1.getMultiLatestPrices)();
    await (0, getReceipts_js_1.getMultiParentPool)();
    //   await getMultiPool();
    const pools = Object.keys(index_js_1.poolInfo);
    for (const key of pools) {
        const tvl = await fetchTVL(key, false);
        tvlMap.set(key, tvl);
    }
    return tvlMap;
}
async function fetchTVL(poolName, ignoreCache) {
    const pool = await (0, index_js_1.getPool)(poolName, ignoreCache);
    if (index_js_1.poolInfo[poolName].parentProtocolName == "NAVI") {
        const poolToken = index_js_1.singleAssetPoolCoinMap[poolName].coin;
        const [priceOfCoin] = await (0, prices_js_1.getLatestPrices)([`${poolToken}/USD`], ignoreCache);
        let tvl = new decimal_js_1.Decimal(0);
        if (index_js_1.poolInfo[poolName].strategyType === "LOOPING") {
            const investor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
            const liquidity = new decimal_js_1.Decimal(investor.content.fields.tokensDeposited);
            const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
            const tokensInvested = liquidity.mul(new decimal_js_1.Decimal(1).minus(debtToSupplyRatio.div(new decimal_js_1.Decimal(1e20))));
            if (poolName == "NAVI-LOOP-SUI-VSUI") {
                const [vsuiPrice] = await (0, prices_js_1.getLatestPrices)([`VSUI/USD`], ignoreCache);
                if (vsuiPrice) {
                    tvl = new decimal_js_1.Decimal(tokensInvested).mul(vsuiPrice).div(1e9);
                }
            }
            else {
                tvl = tokensInvested.div(1e9).mul(priceOfCoin);
            }
        }
        else {
            const liquidity = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
            const tokensInvested = liquidity.div(new decimal_js_1.Decimal(Math.pow(10, 9)));
            tvl = tokensInvested.mul(priceOfCoin);
        }
        return tvl.toString();
    }
    else if (index_js_1.poolInfo[poolName].parentProtocolName == "BUCKET") {
        const poolToken = index_js_1.singleAssetPoolCoinMap[poolName].coin;
        const [priceOfCoin] = await (0, prices_js_1.getLatestPrices)([`${poolToken}/USD`], ignoreCache);
        const liquidity = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
        const tokensInvested = liquidity.div(new decimal_js_1.Decimal(Math.pow(10, index_js_1.coinsList[index_js_1.singleAssetPoolCoinMap[poolName].coin].expo)));
        const tvl = tokensInvested.mul(priceOfCoin);
        return tvl.toString();
    }
    else if (index_js_1.poolInfo[poolName].parentProtocolName === "ALPHAFI") {
        const distributor = await (0, getReceipts_js_1.getDistributor)(ignoreCache);
        const [priceOfAlpha] = await (0, prices_js_1.getLatestPrices)(["ALPHA/USD"], ignoreCache);
        if (pool && distributor && priceOfAlpha) {
            const tokensInvested = new decimal_js_1.Decimal(pool.content.fields.tokensInvested);
            const tvl = tokensInvested.div(1e9).mul(new decimal_js_1.Decimal(priceOfAlpha));
            return tvl.toString();
        }
    }
    else if (index_js_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        const cetus_pool = (await (0, getReceipts_js_1.getParentPool)(poolName, ignoreCache));
        const investor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
        return await fetchAlphafiV3PoolTVL(poolName, cetus_pool, investor, ignoreCache);
    }
    else if (index_js_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
        const bluefin_pool = (await (0, getReceipts_js_1.getParentPool)(poolName, ignoreCache));
        const investor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
        return await fetchAlphafiV3PoolTVL(poolName, bluefin_pool, investor, ignoreCache);
    }
    else if (index_js_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        if (index_js_1.poolInfo[poolName].strategyType === "LOOPING") {
            const poolToken = (0, index_js_1.coinsInPool)(poolName);
            const [priceOfCoin] = await (0, prices_js_1.getLatestPrices)([`${poolToken}/USD`], ignoreCache);
            const investor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
            const liquidity = new decimal_js_1.Decimal(investor.content.fields.tokensDeposited);
            const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
            const tokensInvested = liquidity.mul(new decimal_js_1.Decimal(1).minus(debtToSupplyRatio.div(new decimal_js_1.Decimal(1e20))));
            return tokensInvested.div(1e9).mul(priceOfCoin).toString();
        }
    }
    return "0";
}
async function fetchAlphafiV3PoolTVL(poolName, clmmPool, investor, ignoreCache) {
    const pool = await (0, index_js_1.getPool)(poolName, ignoreCache);
    const pool1 = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const [priceOfCoin0, priceOfCoin1] = await (0, prices_js_1.getLatestPrices)([`${pool1}/USD`, `${pool2}/USD`], ignoreCache);
    const liquidity = new bn_js_1.default(pool.content.fields.tokensInvested);
    const current_sqrt_price = new bn_js_1.default(clmmPool.content.fields.current_sqrt_price);
    let upper_tick = parseInt(investor.content.fields.upper_tick);
    let lower_tick = parseInt(investor.content.fields.lower_tick);
    if (Math.abs(lower_tick - Math.pow(2, 32)) < lower_tick) {
        lower_tick = lower_tick - Math.pow(2, 32);
    }
    if (Math.abs(upper_tick - Math.pow(2, 32)) < upper_tick) {
        upper_tick = upper_tick - Math.pow(2, 32);
    }
    const upper_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(upper_tick);
    const lower_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(lower_tick);
    const { coinA, coinB } = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(liquidity, current_sqrt_price, lower_sqrt_price, upper_sqrt_price, false);
    let amount0 = new decimal_js_1.Decimal(coinA.toString());
    let amount1 = new decimal_js_1.Decimal(coinB.toString());
    const ten = new decimal_js_1.Decimal(10);
    amount0 = amount0.div(ten.pow(index_js_1.coinsList[pool1].expo));
    amount1 = amount1.div(ten.pow(index_js_1.coinsList[pool2].expo));
    const tvl = amount0.mul(priceOfCoin0).add(amount1.mul(priceOfCoin1));
    return tvl.toString();
}
//# sourceMappingURL=getTvls.js.map